import React from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import CustomButton from '../../customButton';
//import { Image } from 'react-bootstrap';
import VerkstedsCSS from './verkstedsCSS.module.css';
import FormModal from '../../formModal';
import UpdateVerkstedForm from '../updateVerksted';

export function VpAdminVerkstedCard({ verksted }) {

    const { username, image } = verksted;


    const removeProduct = async (id) => {
        const confirmDelete = window.confirm('Er du helt sikker på at du vil slette dette verkstedet? Hvis du sletter kan det ikke angres.');
        if (confirmDelete) {
            try {
                // Sjekk om det er en token i localStorage
                const token = localStorage.getItem('token');
                if (!token) {
                    // Hvis det ikke er noen token, be brukeren om å logge inn først
                    console.log('Vennligst logg inn først');
                    return;
                }
    
                // Send delete-forespørselen med autentiseringsheader
                await axios.delete(`https://renowned-oasis-58a898da10.strapiapp.com/api/users/${id}`);
    
                // Vis en melding om at produktet er slettet
                alert('Brukeren er slettet!');
    
                // Omdiriger brukeren til nettbutikken etter sletting
                window.location.href = "/VP/admin/verksteder";
            } catch (error) {
                // Håndter feil ved sletting av produkt
                alert('Feil ved sletting av verksted! Vennligst prøv igjen.');
                console.error('Feil ved sletting av produkt:', error);
            }
        }
    };

    return(
            <div className={VerkstedsCSS.card}>
                {/* <div className="col-12">
                    <Image className={VerkstedsCSS.cardImage} src={image.url} fluid alt={username}/>
                </div> */}
                <div className={VerkstedsCSS.imageContainer} 
                        style={{
                            backgroundImage: `url(${image?.url})`,
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'contain',
                            width: '10em',
                            height: '10em',
                        }}
                    />
                <div className="">
                    <div className={VerkstedsCSS.produktNavn}>
                        {username}
                    </div>
                    {/* <div className="mt-auto">
                        {varenummer}
                    </div> */}
                    <div className="text-center mt-auto">
                    <Link to={`/VP/admin/verksted/${verksted.id}`}>
                        <CustomButton 
                            label="Trykk for mer info"
                            className={VerkstedsCSS.cardButton1}
                        />
                    </Link>
                    </div>
                    <div className="text-center mt-auto">
                        <FormModal 
                            buttonTitle="Rediger informasjon" 
                            modalTitle="Rediger verksted" 
                            body={<UpdateVerkstedForm
                                verksted={verksted} />}
                            openButtonClass={VerkstedsCSS.cardButton2} 
                            closeButtonClass={VerkstedsCSS.closeButton}
                        />
                    </div>
                    <div className="text-center mt-auto">
                        <CustomButton 
                            label="Slett verksted"
                            className={VerkstedsCSS.cardButton3}
                            onClick={() => removeProduct(verksted.id)}
                        />
                    </div>
                </ div>
            </ div>
    )
}

export default VpAdminVerkstedCard;